// extracted by mini-css-extract-plugin
export default {"spinner_container_display":"spinner_spinner_container_display__bOoJ6"};